import { createReducer, on } from '@ngrx/store';
import { DateTime } from 'luxon';
import { Update } from '@ngrx/entity';

import { Counters, DashCounters } from '@apps/auth/domain/models/back/dash-counters';
import { BackAuthCountersLoaded } from '@apps/back/store/auth/auth.actions';
import { Entity } from '@apps/auth/domain/models/back';
import { BackConstants, ExternalStatus } from '@apps/back/back.constants';

import { IEntitiesState, entitiesInitialState, entitiesAdapter } from '../entities.common';
import { ODataAuth } from '../../ODataAuth';
import * as fromBackAuthEntitiesExternal from './entities-external.actions';

export const BackAuthEntitiesExternalFeatureKey = 'external';
export interface IBackAuthEntitiesExternalState
{
    counters: Counters;
    oData: ODataAuth;
    entities: IEntitiesState;
    isEmpty: boolean;
    isLoading: boolean;
    isLoaded: boolean;
    isOups: boolean;
    qsWord: string;
    qsWordImpe: string;
    expirationDate: DateTime;
}

export const BackAuthEntitiesExternalInitialState: IBackAuthEntitiesExternalState =
{
    counters: new Counters(),
    oData: new ODataAuth(BackConstants.QSEntitiesTop, ExternalStatus),
    entities: entitiesInitialState,
    isEmpty: false,
    isLoading: false,
    isLoaded: false,
    isOups: false,
    qsWord: '',
    qsWordImpe: '',
    expirationDate: null
};

export const BackAuthEntitiesExternalReducer = createReducer(
    BackAuthEntitiesExternalInitialState,
    on(
        BackAuthCountersLoaded,
        (state: IBackAuthEntitiesExternalState, { entitiesCounters }: { entitiesCounters: DashCounters, usersCounters: DashCounters; }) =>
            ({
                ...state,
                counters: entitiesCounters.external
            })
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntitiesExternalODataRequested,
        (state: IBackAuthEntitiesExternalState) =>
            ({
                ...state,
                isLoading: !(state.expirationDate !== null && DateTime.utc() < state.expirationDate)
            }),
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntitiesExternalODataLoaded,
        (state: IBackAuthEntitiesExternalState, { entities }: {entities: Entity[]}) =>
            ({
                ...state,
                isLoading: false,
                isOups: false,
                isLoaded: entities && entities.length !== 0,
                entities: entitiesAdapter.setAll(entities, state.entities),
                expirationDate: DateTime.utc().plus({ minutes: BackConstants.DataLifeTime })
            })
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntityExternalUpdated,
        (state: IBackAuthEntitiesExternalState, { entity }: { entity: Update<Entity> }) =>
            ({
                ...state,
                entities: entitiesAdapter.updateOne(entity, state.entities),
            })
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntitiesExternalQsWordSet,
        (state: IBackAuthEntitiesExternalState, { qsWord }: { qsWord: string; }) =>
            ({
                ...state,
                qsWord: qsWord.toLowerCase()
            })
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntitiesExternalQsWordImpeSet,
        (state: IBackAuthEntitiesExternalState, { qsWordImpe }: { qsWordImpe: string; }) =>
            ({
                ...state,
                qsWordImpe: qsWordImpe.toLowerCase()
            })
    ),
    on(
        fromBackAuthEntitiesExternal.BackAuthEntityAddEntitySucceeded,
        (state: IBackAuthEntitiesExternalState, entity: Entity) =>
            ({
                ...state,
                entities: entitiesAdapter.addOne(entity, state.entities)
            })
    )
);
